import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler);

export default function UsageChart({ chartData }) {
  // If no data yet, show a placeholder or empty chart
  const labels = chartData ? chartData.map(d => d.day) : ['...'];
  const counts = chartData ? chartData.map(d => d.count) : [0];

  const data = {
    labels: labels,
    datasets: [{
      label: 'Messages Sent',
      data: counts,
      fill: true,
      borderColor: '#4C1D95',
      backgroundColor: 'rgba(76, 29, 149, 0.1)',
      tension: 0.4,
      pointRadius: 4,
      pointBackgroundColor: '#4C1D95'
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      y: { 
        beginAtZero: true,
        grid: { color: 'rgba(0,0,0,0.05)' } 
      },
      x: { grid: { display: false } }
    }
  };

  return <div style={{ height: '300px' }}><Line data={data} options={options} /></div>;
}